import BaseViewController from "../base-view-controller";

class LanguageMenuViewController extends BaseViewController {
  preprocessScreenData() {
    super.preprocessScreenData();

    const submitFooterParam = "|TDScreenOptionSubmitFooter";
    const { fields } = this.screen;

    if (!("initialLanguageMenuFields" in this.appData.data)) {
      this.appData.data.initialLanguageMenuFields = fields;
    }

    if (!this.appData.values?.renderLanguageSelector) {
      this.screen.fields = this.appData.data.initialLanguageMenuFields.slice(
        0,
        1
      );
      if (
        !!this.screen.footerFields.length &&
        !this.screen.footerFields[0].name.includes("hidden")
      )
        this.screen.footerFields[0].name += " hidden";
    } else {
      this.screen.fields = this.appData.data.initialLanguageMenuFields.slice(
        1,
        2
      );
      this.screen.params = this.screen.params.replace(submitFooterParam, "");
    }
  }

  handleButtonClick(
    name,
    text,
    action,
    replaceHistory,
    initialScreen,
    eventStates
  ) {
    if (name === "language_container") {
      this.screen.footerFields[0].name =
        this.screen.footerFields[0].name.replace(" hidden", "");
      this.appData.handleChange({ renderLanguageSelector: true });
    } else if (name === "dismiss_button") {
      this.appData.handleChange({ renderLanguageSelector: false });
    } else {
      super.handleButtonClick(
        name,
        text,
        action,
        replaceHistory,
        initialScreen,
        eventStates
      );
    }
  }

  confirmButtonAction(language) {
    return {
      type: "dialog",
      value: `confirmation_dialog_${language}`
    };
  }

  handleSelectChange(selected, field) {
    super.handleSelectChange(selected, field);

    const footerFields =
      this.screen.footerFields[0].fieldLayouts[0].containerFields;
    const confirmButton = footerFields.find(f => f.name === "save_button");

    switch (selected.dropdown_language) {
      case "LANGUAGE_EN":
        confirmButton.action = this.confirmButtonAction("english");
        break;
      case "LANGUAGE_ES":
        confirmButton.action = this.confirmButtonAction("spanish");
        break;
      default:
    }
  }
}

export default LanguageMenuViewController;
